import { render, staticRenderFns } from "./JcomPerformanceReport.vue?vue&type=template&id=426d8067"
import script from "./JcomPerformanceReport.vue?vue&type=script&lang=js"
export * from "./JcomPerformanceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports